import React, { Component } from 'react';

class ButtonGroup extends Component {
		constructor(props) {
				super(props);

				this.state = {
						value: this.props.value
				}

				this.buttonClick = this.buttonClick.bind(this);
		}

		buttonClick(e) {
				let value = e.target.innerText;

				this.setState({
						value: value
				})

				this.props.onChange(value);
		}

		render() {
				return (
						<div className={"pp-button-group " + this.props.className}>

								{this.props.options.map((option, index) => (
										<button
												type="button"
												className={'pp-group-button' + (this.props.selected === index ? ' pp-selected' : '')}
												data-index={index}
												key={index}
												onMouseDown={this.buttonClick}>
														{option}
										</button>
								))}

								<input type="hidden" className="pp-button-group-value" value={this.state.value} />
						</div>
				);
		}
}

export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/components/ButtonGroup.js